// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.coinsdo",
    name: "CoinWallet",
    homepage: "https://www.coinsdo.com",
    image_id: "1c0cd352-ce8e-4bcc-f91d-8763eab60b00",
    app: {
        browser: "https://www.coinsdo.com/wallet_coinsdo.html",
        ios: "https://apps.apple.com/us/app/coinsdo-wallet-btc-eth-wallet/id6479635869",
        android: "https://play.google.com/store/apps/details?id=com.coinsdo.wallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: "https://chromewebstore.google.com/detail/coinwallet-btc-crypto-wal/oafedfoadhdjjcipmcbecikgokpaphjk",
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "coinwallet://",
        universal: null,
    },
    desktop: {
        native: "coinwallet://",
        universal: null,
    },
};
//# sourceMappingURL=index.js.map